import React, { useCallback, useContext, useMemo, useRef } from 'react';

const ApiCacheContext = React.createContext(null);

export function ApiCacheProvider({ children }) {
    const cache = useRef(new Map());

    const get = useCallback((url) => cache.current.get(url), []);
    const set = useCallback((url, data) => cache.current.set(url, data), []);
    const invalidate = useCallback((url) => cache.current.delete(url), []);
    const clear = useCallback(() => cache.current.clear(), []);

    const contextValue = useMemo(
        () => ({ get, set, invalidate, clear }),
        [get, set, invalidate, clear]
    );

    return (
        <ApiCacheContext.Provider value={contextValue}>
            {children}
        </ApiCacheContext.Provider>
    );
}

export const useApiCache = () => useContext(ApiCacheContext);
